<template>
  <div class="page-template add-page deliver-add order-add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button v-if="this.$route.query.auditStatus === '20'" :disabled="true" @click="submitAuth" type="primary"
                 plain>保存
      </el-button>
      <el-button v-else @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="examineAndVerify" type="primary" plain :disabled="formModel.auditStatus === null">审核
      </el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm"
                         :formOptions="listFormOptions"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good"
      >选择商品
      </el-button
      >
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800" :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :otherParam="otherParam"
        :tableOptions="tableOptions"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
  </div>
</template>
<script>
// 商品列表组件
import goodList from '@/components/business/goodList';
// 添加要货单组件
import listOperationNew from "@/components/template/listOperationNew";
// 要货单搜索组件
import listOperationForm from '@/components/template/listOperationForm';

import api from '@/config/api';

export default {
  components: {
    listOperationNew,
    goodList,
    listOperationForm
  },
  data() {
    return {
      isCheck: false,
      complexShow: true,
      goodsTxt: "",
      listTableData: [], // 用于传给选择商品组件，判断是否已被选择
      goodListSelect: false,
      title: '',
      goodsCopyList: [],
      listShow: false,
      goodList: [],
      dialogShow: false,
      selectUrl: {url: api.warehouse.warehouseGoods},
      otherParam: {statusList: [10, 20, 30]},
      formModel: {
        auditStatus: null
      },
      // 添加头部字段
      listFormOptions: {
        statusOption: {
          prop: 'auditStatus',
          statusImg: {
            20: '/static/checked.png',
            10: '/static/un-check.png'
          },
          right: '200px',
          top: '30px'
        },
        labelWidth: '120px',
        columns:
          [{
            prop: 'id',
            hidden: true
          },
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 8,
              disabled: true
            },
            {
              label: '引用单号',
              type: 'orderDialog',
              prop: 'allocationOrderNo',
              data: [],
              span: 8,
              url: api.delivery.transferring,
              labelKey: 'orderNo',
              uniqueKey: 'orderNo',
              // change: this.queryRelatedOrderNo,
              disabled: true
            },
            // {
            //   label: '调拨级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
            //   change: this.loginTypeChange,
            //   span: 12,
            //   disabled: true
            // },
            {
              label: '配送中心',
              type: 'storeInputDialog',
              prop: 'distributionStoreId',
              data: [],
              span: 8,
              isHasAll: true,
              url: api.store.store,
              // change: this.getWarehouse,
              disabled: true
            },
            {
              label: '调出仓库',
              type: 'warehouseInputDialog',
              prop: 'distributionWarehouseId',
              data: [],
              span: 8,
              disabled: true
            },
            {
              label: '收货门店',
              type: 'storeInputDialog',
              prop: 'receivingStoreId',
              data: [],
              span: 8,
              isHasAll: true,
              url: api.system.seStore,
              disabled: true
              // change: this.getRequireWarehouseId
            },
            {
              label: '调入仓库',
              type: 'warehouseInputDialog',
              prop: 'receivingWarehouseId',
              data: [],
              disabled: true,
              span: 8
            },
            {
              label: '经手人',
              type: 'input',
              maxLength: 16,
              prop: 'handlerName',
              span: 8
            }]
      },
      // 添加表格字段
      listColumns: {
        disabled: false,
        // 是否显示索引
        indexShow: true,
        summaryColumns: ['blitemNum', 'subtotalAmount'],
        columns: [
          {label: '操作', type: 'operation', width: 100, prop: 'operation'},
          {label: '序号', type: 'index', width: 60, prop: 'idx'},
          {
            label: '条码',
            prop: 'barCode',
            // type: 'input',
            width: '150',
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '100'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '60'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '60'
          },
          {
            label: '类别',
            prop: 'goodsCategoryName',
            width: '100'
          },
          {
            label: '品牌',
            prop: 'goodsBrandName',
            width: '100'
          },
          {
            label: '配送价',
            prop: 'deliveryPrice',
            width: '100'
          },
          {
            label: '数量',
            width: '100',
            prop: 'blitemNum',
            type: 'inputNumber',
            change: this.numChange,
            max: 9999.999,
            precision: 3
          },
          {
            label: '差异数量',
            width: '100',
            prop: 'differenceNum',
            precision: 2
          },
          {
            label: '小计金额',
            prop: 'subtotalAmount',
            width: '100'
          },
          // {
          //   label: '当前门店库存',
          //   prop: 'inventoryNum',
          //   width: '120'
          // },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '80'
          },
          {
            label: '备注',
            prop: 'remarks',
            maxLength: 16,
            type: 'input',
            width: '200'
          },

        ],
        url: api.warehouse.blitem
      },
      // 表格信息配置
      tableOptions: {
        // 是否显示索引
        indexShow: true,
        // 自定义列索引
        indexMethod: (index) => {
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '200',
            align: 'center'
          },
          {
            label: '品名',
            prop: 'goodsName',
            width: '100',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '100',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '200',
            align: 'center'
          },
          {
            label: '配送价',
            prop: 'deliveryPrice',
            width: '150',
            align: 'center'
          }
        ],
        param: this.otherParam,
        url: api.archives.goodsInfoIncludeSpecs
      },

      differenceDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '200px',
          top: '30px',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '差异单号',
            prop: 'orderNo',
          },
          {
            label: '调出门店',
            prop: 'outerStoreName'
          },
          {
            label: '调出仓库',
            prop: 'outerWarehouseName'
          },
          {
            label: '调入门店',
            prop: 'enterStoreName'
          },
          {
            label: '调入仓库',
            prop: 'enterWarehouseName'
          },
          {
            label: '经手人',
            prop: 'handler',
          },
          {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          allocationDifferenceOrderMapList: {
            url: api.delivery.differenceGoods + "/page",
            indexShow: true,
            height: this.detailHeight,
            tableName: "allocationDifferenceOrderMapList",
            showSummary: true,
            summaryColumns: ['outerNum', 'enterNum', 'differenceNum', 'differenceAmount'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: '出库数量',
                prop: 'outerNum',
                align: "center"
              },
              {
                label: '入库数量',
                prop: 'enterNum',
                align: "center"
              },
              {
                label: '差异数量',
                prop: 'differenceNum',
                align: "center"
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: "center"
              },
              {
                label: '差异金额',
                prop: 'differenceAmount',
                align: "center"

              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },
        // 打印的列表
        printTablesProp: {
          allocationDifferenceOrderMapList: {
            tableName: 'allocationDifferenceOrderMapList',
            showSummary: true,
            summaryColumns: ['outerNum', 'enterNum', 'differenceNum', 'differenceAmount'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: '出库数量',
                prop: 'outerNum',
                align: "center"
              },
              {
                label: '入库数量',
                prop: 'enterNum',
                align: "center"
              },
              {
                label: '差异数量',
                prop: 'differenceNum',
                align: "center"
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: "center"
              },
              {
                label: '差异金额',
                prop: 'differenceAmount',
                align: "center"

              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.delivery.differenceOrder
      },
      checkIndex: ''
    }
  },
  created() {
    this.title = document.title + (this.$route.query.id ? '-编辑' : '-新增');
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    //点击 高级搜索显示
    complexFunc() {
      if (!this.isCheck) {
        this.complexShow = !this.complexShow;
      }
    },
    // 编辑回显数据
    getDetail() {
      this.loading = true;
      this.$axios
        .fetchGet(api.delivery.deliver + '?id=' + this.$route.query.id, {})
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.$nextTick(() => {
              // 为头部表单赋值
              this.$refs.listOperationForm.formModel = data.data;
              this.formModel.auditStatus = data.data.auditStatus;
              // 处理字段值与配置的表格值不一致的地方
              // 此处为示例，其他需要处理的值请各自根据业务处理
              data.data.goodsMapMVOList.map(item => {
                item.id = item.goodsId;
                item.name = item.goodsName;
                item.barCode = item.goodsBarCode;
                item.specs = item.goodsSpecs;
                item.unitName = item.goodsUnitName;
                item.blitemNum = item.goodsNum;
                item.inventoryNum = item.goodsInventoryNum;
              });
              this.goodsCopyList = this.$utils.deepClone(
                data.data.goodsMapMVOList
              );
              // this.goodsCopyList.map((item) => {
              //   item.goodsNum = item.goodsNum;
              // });
              // 为表格赋值
              // this.loginTypeChange({relateType: data.data.relateType});
              this.getWarehouse({distributionStoreId: data.data.distributionStoreId});
              this.getRequireWarehouseId({receivingStoreId: data.data.receivingStoreId});
              this.$refs['listOperation'].addMoreRow(data.data.goodsMapMVOList, 0);
              this.currentTableList = this.$refs['listOperation'].getTabelData();
            });
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
    },
    search() {
      if (this.goodsTxt === '' || this.goodsTxt === null) return;
      this.otherParam.otherName = this.goodsTxt;
      if (this.isSelectWarehouse) {
        this.goodsTxt = '';
        this.$confirm("请选择调入门店！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } else {
        this.isCheck = true;
        this.$axios
          .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
          .then(res => {
            if (res.code === 200) {
              if (res.data.length > 0) {
                let tableData = res.data;
                if (tableData.length === 1) {
                  let row = tableData[0];
                  let tableList = this.$refs["listOperation"].getTabelData();
                  let flag = true;
                  if (tableList.length > 0) {
                    tableList.forEach(item => {
                      if (flag) {
                        if (item.barCode === row.barCode) flag = false;
                      }
                    });
                  }
                  if (!flag) {
                    this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                    return;
                  }
                  row.subtotalAmount = '0.00';
                  // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                  this.$refs["listOperation"].setColumnData(row, tableList.length);
                  this.currentTableList = this.$refs["listOperation"].getTabelData();
                  this.$message.success("商品添加成功");
                } else {
                  this.checkGoods();
                }
              } else {
                this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
              }
            } else {
              this.$message({type: "error", message: res.msg});
            }
          })
          .catch(err => {
          }).finally(() => {
          this.clearQueryParam();
          this.isCheck = false;
        });
      }

    },
    clearQueryParam() {
      this.goodsTxt = '';
      this.otherParam.otherName = '';
    },
    // 通过数量计算小计金额
    numChange(row, index) {
      console.log(row);
      console.log(index)
      let rowData = this.$utils.deepClone(this.currentTableList[index]);
      if (row.blitemNum === '' || row.blitemNum == null) {
        row.blitemNum = rowData.blitemNum.toString();
        return;
      }
      if (this.goodsCopyList.length !== 0) {
        this.goodsCopyList.map((item) => {
          if (item.barCode === row.barCode) {
            if (row.blitemNum > item.goodsNum) {
              this.$confirm(
                row.name + '：现可配送的数量最多为' + item.goodsNum + '，多余部分请重新制定！', '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
                row.blitemNum = item.goodsNum;
                this.updateData(row, index);
              }).catch(() => {
                row.blitemNum = item.goodsNum;
                this.updateData(row, index)
              });
            } else {
              row.differenceNum = (item.goodsNum - row.blitemNum).toFixed(2);
              this.updateData(row, index);
            }
          }
        });
      }
    },

    updateData(row, index) {
      if (row.subtotalAmount) {
        row.subtotalAmount = parseFloat(row.deliveryPrice * row.blitemNum).toFixed(2);
      }
      this.$refs['listOperation'].setCountData(row, index);
    },

    // 选择某行数据
    rowCheck(row) {
      this.listShow = false;
      row.subtotalAmount = '0.00';
      this.$refs['listOperation'].setColumnData(row, this.checkIndex);
      this.currentTableList = this.$refs['listOperation'].getTabelData();
    },
    // 商品多选，确认事件
    rowsSelectSubmit(rows) {
      this.listShow = false;
      rows.map(item => {
        item.subtotalAmount = '0.00';
      });
      let tableList = this.$refs['listOperation'].getTabelData();
      this.$refs['listOperation'].addMoreRow(rows, tableList.length);
      this.currentTableList = this.$refs['listOperation'].getTabelData();
      if (rows && rows.length > 0) {
        this.$message.success("商品添加成功");
      }
    },

    // 返回按钮事件
    beBack() {
      if (!this.isCheck) {
        this.$router.go(-1);
      }
    },

    // 刷新按钮事件
    refresh() {
      if (!this.isCheck) {
        this.$router.go(0);
      }
    },

    // 选择商品安装事件
    checkGoods() {
      this.listShow = true;
      this.goodListSelect = true;
      this.listTableData = this.$refs['listOperation'].getTabelData()// table数据
    },

    // 提交数据
    submitAuth() {
      if (!this.isCheck) {
        let isSave = false;
        let tableList = this.$refs['listOperation'].getTabelData();
        isSave = tableList.every(v => {
          if (v.goodsNum > 0) {
            return true
          } else {
            return false
          }
        })
        if (isSave) {
          this.$confirm('是否保存，请确认数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let orderNumber = 1;
            tableList.map(item => {
              item.orderNumber = orderNumber++;
              item.goodsNum = item.blitemNum;
            });
            let totalParam = this.$refs['listOperation'].getSumData();
            totalParam.billAmount = totalParam.subtotalAmount;
            let headParam = this.$refs.listOperationForm.getFormModel();
            headParam.auditStatus = this.formModel.auditStatus;
            let searchParam = {
              ...{goodsMapMVOList: tableList}, ...totalParam, ...headParam
            };

            let axiosUrl = '';
            if (headParam.id) {
              searchParam.operateFlag = 'update';
              axiosUrl = '/api/eros/dn/dnDistributionOrder/updatedistributionorder';
            } else {
              axiosUrl = '/api/eros/dn/dnDistributionOrder/insertdistributionorder';
            }
            const loading = this.$loading({
              lock: true,
              text: '提交中，请稍候...',
              background: 'rgba(225, 225, 225, 0.8)'
            });
            this.$axios
              .fetchPost(axiosUrl, searchParam)
              .then(data => {
                this.loading = false;
                if (data.code == 200) {
                  this.dialogShow = false;
                  // this.$router.push({path: '/delivery/deliver'});
                  this.$refs.listOperationForm.formModel = data.data;
                  this.formModel.auditStatus = data.data.auditStatus;
                  this.$notify({
                    type: "success",
                    title: '保存操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({message: '保存成功！', type: 'success'});
                } else {
                  this.$message({message: data.msg, type: 'error'});
                }
              })
              .catch(err => {
                console.log(err);
                this.$message({message: '请求失败！', type: 'error'});
                this.loading = false;
              }).finally(() => {
              loading.close()
            })
          });
        } else {
          this.$message({message: '存在数量为0的商品，如需保存或审核请删除数量为0的商品', type: 'warning'});
        }
      }
    },

    // 引用调拨单单号
    queryRelatedOrderNo(formModel) {
      let allocationOrderNo = this.listFormOptions.columns.filter(item => item.prop === 'allocationOrderNo')[0];
      allocationOrderNo.data.map(item => {
        if (item.orderNo == formModel.allocationOrderNo) {
          this.loading = true;
          this.$axios
            .fetchGet(api.delivery.transferring + '?id=' + item.id, {})
            .then(data => {
              this.loading = false;
              if (data.code == 200) {
                this.$nextTick(() => {
                  // 为头部表单赋值
                  // this.$refs.listOperationForm.formModel = data.data;
                  // 处理字段值与配置的表格值不一致的地方
                  // 此处为示例，其他需要处理的值请各自根据业务处理
                  data.data.goodsMapMVOList.map(item => {
                    item.id = item.goodsId;
                    item.name = item.goodsName;
                    item.barCode = item.goodsBarCode;
                    item.specs = item.goodsSpecs;
                    item.unitName = item.goodsUnitName;
                    item.blitemNum = item.goodsNum;
                    item.inventoryNum = item.goodsInventoryNum;
                  });
                  // 为表格赋值
                  this.$refs['listOperation'].addMoreRow(data.data.goodsMapMVOList, 0);
                  this.currentTableList = this.$refs['listOperation'].getTabelData();
                });
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            })
            .catch(err => {
              console.log(err);
              this.$message({message: '请求失败！', type: 'error'});
              this.loading = false;
            });
        }
      })
    },

    // 审核按钮事件(10：调出审核 30：调入审核)
    examineAndVerify() {
      if (!this.isCheck) {
        this.$confirm('是否审核数据，请确认?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let tableList = this.$refs['listOperation'].getTabelData();
            let orderNumber = 1;
            tableList.map(item => {
              item.orderNumber = orderNumber++;
              item.goodsNum = item.blitemNum;
            });
            let totalParam = this.$refs['listOperation'].getSumData();
            totalParam.billAmount = totalParam.subtotalAmount;
            let headParam = this.$refs.listOperationForm.getFormModel();
            let searchParam = {
              ...{goodsMapMVOList: tableList}, ...totalParam, ...headParam
            };
            searchParam.operateFlag = 'examine';
            const loading = this.$loading({
              lock: true,
              text: '提交中，请稍候...',
              background: 'rgba(225, 225, 225, 0.8)'
            });
            this.$axios.fetchPost('/api/eros/dn/dnDistributionOrder/updatedistributionorder', searchParam).then(data => {
              this.loading = false;
              if (data.code === 200) {
                this.$notify({
                  type: "success",
                  title: '审核操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '审核成功!', type: 'success'});
                if (data.data.differenceId) {
                  this.$confirm('差异单' + data.data.differenceOrderNo + '已生成', '提示',
                    {
                      confirmButtonText: '查看',
                      cancelButtonText: '关闭',
                      type: 'warning'
                    }
                  ).then(() => {
                    this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.differenceDetailColumns);
                    const {href} = this.$router.resolve({
                      name: 'DifferenceDetail',
                      query: {id: data.data.differenceId}
                    });
                    window.open(href, '_blank');
                  }).catch(() =>
                      this.dialogShow = false,
                    this.$router.push({path: '/delivery/deliver'}));
                } else {
                  this.dialogShow = false;
                  this.$router.push({path: '/delivery/deliver'});
                }
              } else {
                if (data.errorMsg) {
                  this.$message({message: data.errorMsg, type: 'error'});
                } else {
                  this.$message({message: data.msg, type: 'error'});
                }
              }
            })
              .catch(err => {
                console.log(err);
                this.$message({message: '请求失败！', type: 'error'});
                this.loading = false;
              }).finally(() => {
              loading.close()
            })
          })
          .catch(() => {
            // this.$message({type: 'info', message: '已取消删除'});
          });
      }
    },
    // 获取用户信息
    // getUserInfo() {
    //   let user = this.$utils.getSysUser();
    //   if (user.type === 10) {
    //     this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].hidden = false;
    //   } else {
    //     this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].hidden = false;
    //     //根据门店获取相应仓库
    //     this.$axios.fetchPost(api.warehouse.warehouse + '/list', {}).then(data => {
    //       if (data.code === 200) {
    //         this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].data = data.data;
    //         data.data.map(item => {
    //           if (item.defaultState === true) {
    //             this.$refs.listOperationForm.formModel.distributionWarehouseId = item.id;
    //           }
    //         })
    //       }
    //     })
    //   }
    // },
    loginTypeChange(form) {
      if (form.relateType === 10) {
        // 选择总部的时候，查询商户相应仓库
        this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].hidden = false;
        this.listFormOptions.columns.filter(item => item.prop === 'distributionStoreId')[0].hidden = true;
        // 根据商户获取相应仓库
        this.$refs.listOperationForm.formModel.distributionWarehouseId = '';
        this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].data = [];
        this.$axios.fetchPost(api.warehouse.warehouse + '/warehouse/list', {relateType: form.relateType}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].data = data.data;
            data.data.map(item => {
              if (item.defaultState === true) {
                this.$refs.listOperationForm.formModel.distributionWarehouseId = item.id;
                this.otherParam.warehouseId = item.id;
              }
            })
          }
        })
      } else {
        // 选择门店的时候，查询商户相应的门店
        this.listFormOptions.columns.filter(item => item.prop === 'distributionStoreId')[0].hidden = false;
        this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].hidden = false;
        // this.$refs.listOperationForm.formModel.distributionWarehouseId = "";
        // this.$refs.listOperationForm.formModel.distributionStoreId = "";
        this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].data = [];
        this.listFormOptions.columns.filter(item => item.prop === 'distributionStoreId')[0].data = [];
        this.$axios.fetchPost(api.system.seStore + '/list', {}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'distributionStoreId')[0].data = data.data;
          }
        })
      }
    },
    getWarehouse(form) {
      // 根据门店获取相应仓库
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.distributionStoreId}).then(data => {
        if (data.code === 200) {
          this.listFormOptions.columns.filter(item => item.prop === 'distributionWarehouseId')[0].data = data.data;
          data.data.map(item => {
            if (item.defaultState === true) {
              this.$refs.listOperationForm.formModel.distributionWarehouseId = item.id;
              this.otherParam.warehouseId = item.id;
            }
          })
        }
      })
    },
    getRequireWarehouseId(form) {
      // 根据门店获取相应仓库
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.receivingStoreId}).then(data => {
        if (data.code === 200) {
          this.listFormOptions.columns.filter(item => item.prop === 'receivingWarehouseId')[0].data = data.data;
          data.data.map(item => {
            if (item.defaultState === true) {
              this.$refs.listOperationForm.formModel.receivingWarehouseId = item.id;
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
  .deliver-add .el-select, .deliver-add .el-input {
    width: 300px;
  }

  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/page/delivery/DeliverAdd.vue